module.exports = __webpack_public_path__ + "img/curfox1.e2b9682b.png";